import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DateFnsAdapter, MAT_DATE_FNS_FORMATS } from '@angular/material-date-fns-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { getLocale } from '@vendasta/galaxy/utility/locale';
import { GalaxyFormFieldModule } from '@vendasta/galaxy/form-field';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'orders-contract-start',
  styleUrls: ['../order-details.component.scss', './contract-start.component.scss'],
  template: `
    <span
      class="column-title"
      matTooltip="{{ 'SALES_ORDERS.CONTRACT_START_HINT' | translate }}"
      matTooltipPosition="above"
    >
      {{ 'LIB_ORDERS.COMMON.ORDER_DETAILS.CONTRACT_START' | translate }}
    </span>
    <glxy-form-field class="column-content date-picker" [showLabel]="false">
      <input
        dense
        matInput
        [ngModel]="contractStartDate"
        (ngModelChange)="handleDateChange($event)"
        [min]="minDate"
        [matDatepicker]="picker"
        [disabled]="viewOnly"
      />
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker #picker></mat-datepicker>
      @if (!contractStartDate) {
        <mat-error>{{ 'LIB_ORDERS.COMMON.ORDERS.REQUIRED' | translate }}</mat-error>
      }
    </glxy-form-field>
  `,
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: getLocale() },
    {
      provide: DateAdapter,
      useClass: DateFnsAdapter,
      deps: [MAT_DATE_LOCALE],
    },
    { provide: MAT_DATE_FORMATS, useValue: MAT_DATE_FNS_FORMATS },
  ],
  imports: [
    GalaxyFormFieldModule,
    FormsModule,
    MatFormFieldModule,
    MatDatepickerModule,
    MatTooltipModule,
    TranslateModule,
  ],
})
export class OrderContractStartComponent {
  @Input() minDate: Date;
  @Input() contractStartDate: Date;
  @Input() viewOnly = false;

  @Output() contractStartDateChange = new EventEmitter<Date>();

  handleDateChange(event: Date): void {
    this.contractStartDateChange.emit(event);
  }
}
